
import {AuthenAction} from '@/store/auth/auth.actions';
import {AuthInitState, AuthLogin} from '@/store/auth/auth.types';
import {AuthenMutations} from '@/store/auth/auth.mutations';

const namespaced = true;

export const authInitState: AuthInitState = {
  auth: {} as AuthLogin
};

export const authState = {
  namespaced,
  state: authInitState,
  actions: AuthenAction,
  mutations: AuthenMutations,
  // getters
};
